import { render, staticRenderFns } from "./registration_success.vue?vue&type=template&id=5612b139&scoped=true&"
import script from "./registration_success.vue?vue&type=script&lang=js&"
export * from "./registration_success.vue?vue&type=script&lang=js&"
import style0 from "./registration_success.vue?vue&type=style&index=0&id=5612b139&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612b139",
  null
  
)

export default component.exports